import React, { Component } from 'react'
import { Form } from 'react-bootstrap'
import SelectRC, { Option } from 'rc-select'

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faChevronDown } from '@fortawesome/pro-duotone-svg-icons/faChevronDown'
class DisplayItemTextSettings extends Component {
    constructor(props) {
        super(props)
        this.state = {
            validators:
                this.props.item &&
                    this.props.item.settings &&
                    this.props.item.settings.validators
                    ? this.props.item.settings.validators
                    : [],
            phone_number:
                this.props.item &&
                    this.props.item.settings &&
                    this.props.item.settings.phone_number
                    ? this.props.item.settings.phone_number
                    : null,
            company_lookup:
                this.props.item &&
                    this.props.item.settings &&
                    this.props.item.settings.company_lookup
                    ? this.props.item.settings.company_lookup
                    : null,
            company_key:
                this.props.item &&
                    this.props.item.settings &&
                    this.props.item.settings.company_key
                    ? this.props.item.settings.company_key
                    : null,
        }
        this.onChangeValidators = this.onChangeValidators.bind(this)
    }

    onChangeValidators(options) {
        let validators = []
        if (options) {
            options.forEach((item) => {
                validators.push(item.value)
            })
        }

        this.setState({ validators: validators })
        this.props.onChange('validators', validators)
    }

    onChangeCompanyItem(option) {
        this.setState({ company_key: option.value })
        this.props.onChange('company_key', option.value)
    }

    render() {
        const kedo = this.props.kedo
        const validatorOptions = [
            { value: 'BSN', label: kedo.t('BSN') },
            { value: 'IBAN', label: kedo.t('IBAN') },
            { value: 'UniqueValue', label: kedo.t('UniqueValue') },
        ]
        const companyKeyOptions = [
            { value: 'kvkNummer', label: kedo.t('kvkNummer') },
            { value: 'straatnaam', label: kedo.t('straatnaam') },
            { value: 'vestigingsnummer', label: kedo.t('vestigingsnummer') },
            { value: 'postcode', label: kedo.t('postcode') },
            { value: 'plaats', label: kedo.t('plaats') },
            { value: 'location', label: kedo.t('location') },
            { value: 'huisnummer', label: kedo.t('huisnummer') },
        ]

        let selected = []

        validatorOptions.forEach((item) => {
            if (
                this.state.validators &&
                Array.isArray(this.state.validators) &&
                this.state.validators.includes(item.value)
            ) {
                selected.push(item)
            }
        })

        const filteredOptions = validatorOptions.filter(
            (option) =>
                !selected.some((selected) => selected.value === option.value)
        )

        return (
            <div>
                <Form.Group>
                    <Form.Label>{this.props.kedo.t('Validators')}</Form.Label>
                    <SelectRC
                        className="w-100 custom-select-react"
                        id={`${this.props.item.id}-text-settings`}
                        mode="multiple"
                        allowClear
                        onChange={(selectedItems) => {
                            const selectedOptions = selectedItems.map(
                                (selectedItem) =>
                                    validatorOptions.find(
                                        (option) =>
                                            option.value === selectedItem.value
                                    )
                            )
                            this.onChangeValidators(selectedOptions)
                        }}
                        suffixIcon={<FontAwesomeIcon icon={faChevronDown} />}
                        placeholder={this.props.kedo.t('Choose an option')}
                        value={selected.map((item) => ({
                            value: item.value,
                            label: item.label,
                        }))}
                        labelInValue
                        notFoundContent={this.props.kedo.t('No items found')}
                    >
                        {filteredOptions.map((option) => (
                            <Option key={option.id} value={option.value}>
                                {option.label}
                            </Option>
                        ))}
                    </SelectRC>
                </Form.Group>
                <Form.Group>
                    <Form.Check
                        type={'checkbox'}
                        label={kedo.t('Phone number')}
                        onChange={(e) => {
                            this.setState({ phone_number: e.target.checked })
                            this.props.onChange(
                                'phone_number',
                                e.target.checked
                            )
                        }}
                        name={'phone_number'}
                        checked={this.state.phone_number === true}
                    />
                </Form.Group>
                <Form.Group>
                    <Form.Check
                        type={'checkbox'}
                        label={kedo.t('company lookup')}
                        onChange={(e) => {
                            this.setState({ company_lookup: e.target.checked })
                            this.props.onChange(
                                'company_lookup',
                                e.target.checked
                            )
                        }}
                        name={'company_lookup'}
                        checked={this.state.company_lookup === true}
                    />
                </Form.Group>

                {
                    this.state.company_lookup && <Form.Group>
                        <Form.Label>{this.props.kedo.t('Company key')}</Form.Label>
                        <SelectRC
                            defaultValue={"kvkNummer"}
                            className="w-100 custom-select-react"
                            id={`${this.props.item.id}-company-keys`}
                            mode="default"
                            allowClear
                            onChange={(selectedItems) => {

                                this.onChangeCompanyItem(selectedItems)
                            }}
                            suffixIcon={<FontAwesomeIcon icon={faChevronDown} />}
                            placeholder={this.props.kedo.t('Choose an option')}
                            value={companyKeyOptions.find((key) => key == this.setState.company_key)}
                            labelInValue
                            notFoundContent={this.props.kedo.t('No items found')}
                        >
                            {companyKeyOptions.map((option) => (
                                <Option key={option.id} value={option.value}>
                                    {option.label}
                                </Option>
                            ))}
                        </SelectRC>
                    </Form.Group>
                }
            </div>
        )
    }
}

export default DisplayItemTextSettings
